import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Building2 } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
          {/* Logo */}
          <div className="flex items-center space-x-3 mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_erection-expert/artifacts/8ji3vrt1_ChatGPT%20Image%20Feb%2027%2C%202026%20at%2001_11_52%20PM.png" 
              alt="Durga Engineering Works"
              className="h-12 w-auto"
            />
          </div>
            <p className="text-sm mb-4 max-w-md">
              Since 2007, delivering precision structural fabrication and industrial erection services across India. 
              Trusted by leading steel plants and ferro alloy units.
            </p>
            <div className="flex items-center space-x-2 text-sm">
              <Building2 size={16} className="text-orange-500" />
              <span className="font-oswald text-white">Est. 2007 | 500+ Workforce</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-oswald text-white font-bold text-lg mb-4">QUICK LINKS</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm hover:text-orange-500 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-sm hover:text-orange-500 transition-colors">Services</Link></li>
              <li><Link to="/projects" className="text-sm hover:text-orange-500 transition-colors">Projects</Link></li>
              <li><Link to="/infrastructure" className="text-sm hover:text-orange-500 transition-colors">Infrastructure</Link></li>
              <li><Link to="/quotation" className="text-sm hover:text-orange-500 transition-colors">Request Quote</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-oswald text-white font-bold text-lg mb-4">CONTACT</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <MapPin size={16} className="text-orange-500 mt-1 flex-shrink-0" />
                <span>Vill + P.O: Ghutgoria, P.S: Barjora<br />Dist: Bankura - 722202<br />West Bengal, India</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Phone size={16} className="text-orange-500" />
                <a href="tel:+917364909315" className="hover:text-orange-500 transition-colors">+91 7364909315</a>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Mail size={16} className="text-orange-500" />
                <a href="mailto:eng.durga@gmail.com" className="hover:text-orange-500 transition-colors">eng.durga@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Durga Engineering Works. All rights reserved.</p>
          <p className="text-xs mt-2 text-slate-500">Structural Steel Fabrication | Industrial Erection | Mechanical Construction</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;